import React, { Component } from 'react';
import { Select, message } from 'antd';
import { connect } from 'react-redux';

import { changeWidgetPosition } from '../../../../../actions';

const Option = Select.Option;

class WidgetSelect extends Component {
  onChange = (value) => {
    if (value === 'null') {
      this.props.changeWidgetPosition({
        _id: this.props.selected._id,
        data: { newPosition: 0 },
        response: {
          success: async () => {
            message.success(`Bỏ trống danh mục tại vị trí ${this.props.index} thành công`);
          },
          failure: async (msg = `Bỏ trống danh mục tại vị trí ${this.props.index} không thành công`) => {
            message.error(msg);
          },
        },
      }); 
    } else {
      this.props.changeWidgetPosition({
        _id: value,
        data: { newPosition: this.props.index },
        response: {
          success: async () => {
            message.success(`Đổi danh mục tại vị trí ${this.props.index} thành công`);
          },
          failure: async (msg = `Đổi danh mục tại vị trí ${this.props.index} không thành công`) => {
            message.error(msg);
          },
        },
      }); 
    }
  }
  
  render() {
    const { categories, selected } = this.props;
    
    return (
      <Select placeholder="Chọn danh mục" value={selected ? selected._id : 'null'} onChange={this.onChange}>
        {<Option key='null' value={'null'}>Trống</Option>}
        {categories.map(category => (
          <Option 
            key={category._id}
            value={category._id}
            disabled={category.widgetPosition > 0}
          >
            {category.name}
          </Option>
        ))}
      </Select>
    );
  }
}

export default connect(() => ({
  
}), {
  changeWidgetPosition,
})(WidgetSelect);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/WidgetSelect.js